// Enterprise-site level: a small campus drawing (buildings, paths, parking, trees and
// the mission route) placed at the RouteZero facility. Drawn in local units
// (0..100 × 0..64) and scaled into SITE_BOX on the map.

import { s } from './mapRenderer.js';
import { project, SITE_BOX } from './mapData.js';

export function siteScene(city, layout) {
  const [fx, fy] = project(...city.site.at);
  const sx = SITE_BOX.w / 100; const sy = SITE_BOX.h / 64;
  const g = s('g', { class: `site-scene kind-${city.site.kind}`, 'data-site': city.domainId, transform: `translate(${fx - SITE_BOX.w / 2} ${fy - SITE_BOX.h / 2}) scale(${sx} ${sy})` });
  g.append(
    s('rect', { class: 'site-ground-shadow', x: 1.2, y: 1.6, width: 100, height: 64, rx: 5 }),
    s('rect', { class: 'site-ground', x: 0, y: 0, width: 100, height: 64, rx: 5 }),
    s('rect', { class: 'site-lawn', x: 3, y: 31, width: 36, height: 30, rx: 3 }),
  );
  // internal roads
  g.append(s('path', { class: 'site-road', d: 'M0 32H100M41 32V64M71 0V32M2 4H98' }));
  // parking lot
  const park = s('g', { class: 'site-parking' }, s('rect', { x: 6, y: 40, width: 30, height: 15, rx: 1.5 }));
  for (let x = 9; x < 36; x += 3.4) park.append(s('path', { class: 'site-bay', d: `M${x} 40.8V45.6M${x} 49.4V54.2` }));
  g.append(park);
  // trees
  [[4, 30], [12, 58], [24, 59], [38, 36], [86, 30], [92, 58], [97, 36], [80, 60], [62, 60], [30, 28]].forEach(([x, y], i) =>
    g.append(s('circle', { class: 'site-tree', cx: x, cy: y, r: 1.6 + (i % 3) * 0.4 })));
  // buildings: drop shadow + body + roof band + windows
  for (const b of layout.buildings) {
    const bg = s('g', { class: `site-building slot-${b.slot}`, 'data-slot': b.slot },
      s('rect', { class: 'bld-shadow', x: b.x + 1.1, y: b.y + 1.4, width: b.w, height: b.h, rx: 1.2 }),
      s('rect', { class: 'bld-body', x: b.x, y: b.y, width: b.w, height: b.h, rx: 1.2 }),
      s('rect', { class: 'bld-roof', x: b.x, y: b.y, width: b.w, height: 3.2, rx: 1.2 }));
    for (let wx = b.x + 1.6; wx < b.x + b.w - 1.6; wx += 2.6) {
      for (let wy = b.y + b.h - 2.6; wy < b.y + b.h - 1.2; wy += 3) bg.append(s('rect', { class: 'bld-window', x: wx, y: wy, width: 1.8, height: 1.6, rx: 0.3 }));
    }
    g.append(bg);
  }
  return g;
}
